import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { colors, fontSize } from "style";
import Icon, { ICON_SIZE, ICON_TYPE } from "components/Icon";
import { ApplicantsShareModal } from "components/Missions/Applicants";

/**
 * ApplicantsShareButton
 *
 * @param {Array} selected
 */
const ApplicantsShareButton = ({ selected, ...props }) => {
  const [showShareModal, setShowShareModal] = useState(false);

  return (
    <>
      <button type="button" onClick={() => setShowShareModal(true)} css={styles.button} {...props}>
        <Icon type={ICON_TYPE.share} size={ICON_SIZE.small} />
        <FormattedMessage id="Missions.Applicants.ApplicantsShareButton.Text" />
      </button>

      {showShareModal && <ApplicantsShareModal applicantIds={selected} onClose={() => setShowShareModal(false)} show />}
    </>
  );
};

const styles = {
  button: css`
    height: 2.8rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: ${colors.purpleRainBase};
    font-size: ${fontSize.small};
    color: ${colors.white};
    font-weight: 500;
    border: none;
    border-radius: 2rem;
    padding: 0.4rem 1rem;
    cursor: pointer;
    transition: background 0.2s ease;

    &:disabled {
      color: ${colors.grayAnatomyLight2};
      background: ${colors.grayAnatomyLight4};
      border-color: ${colors.grayAnatomyLight4};
    }

    &:hover:not(:disabled) {
      background: ${colors.purpleRainDark1};
    }
  `,
};

ApplicantsShareButton.propTypes = {
  selected: PropTypes.array.isRequired,
};

export default ApplicantsShareButton;
